import { useLayoutEffect, useRef } from "react";
import About from "../components/About";
import MiniProfile from "../components/MiniProfile";
import NavLinks from "../components/NavLinks";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";
export default function SideBar() {
  const sidebarRef = useRef(null);
  const { isAuth } = useAuth();
  useLayoutEffect(() => {
    const sidebar = sidebarRef.current;
    document.documentElement.style.setProperty("--sidebar-width", `${sidebar.offsetWidth}px`);
  }, []);
  return (
    <div className="side-bar" ref={sidebarRef}>
      <div style={{ margin: "0 auto" }}>
        <Logo />
      </div>
      <NavLinks position={"sidebar"} />
      <MiniProfile position={"sidebar"} />
      {!isAuth && <About />}
    </div>
  );
}
